import { Pipe, PipeTransform } from '@angular/core';
import { utcToZonedTime } from 'date-fns-tz';

@Pipe({
  name: 'utcToZonedTime',
  standalone: true,
})
export class UtcToZonedTimePipe implements PipeTransform {
  transform(
    date: string | number | Date,
    timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
  ): Date {
    return utcToZonedTime(date, timezone);
  }
}
